<div class="campaign-page-container" *ngIf="campaignPage && showPage">
  <div class="promo-period-container">
    <div class="promo-period-heading">
      <h1>{{ campaignPage.mainHeading }}</h1>
      <h2>{{ campaignPage.subHeading }}</h2>
    </div>
    <div class="promo-period-widget">
      <div class="promo-period-image">
        <img
          class="promo-desktop-image"
          [src]="campaignPage.promoPeriodImageUrlDesktop"
          alt="" />
        <img
          class="promo-mobile-image"
          [src]="campaignPage.promoPeriodImageUrlMobile"
          alt="" />
      </div>
      <div class="promo-period-value">
        <img class="promo-icon" [src]="campaignPage.promoPeriodIcon" alt="" />
        <div class="promo-period-text">
          <h3>{{ campaignPage.promoPeriodHeading }}</h3>
          <span class="value" [innerHTML]="campaignPage.promoPeriod"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="main-container">
    <img
      class="hero-desktop-image"
      [src]="campaignPage.heroImageUrlDesktop"
      alt="" />
    <img
      class="hero-mobile-image"
      [src]="campaignPage.heroImageUrlMobile"
      alt="" />
    <p
      class="hero-description"
      [innerHTML]="campaignPage.heroImageDescription"></p>
    <h2 class="main-description-heading">
      {{ campaignPage.mainDescriptionHeading }}
    </h2>
    <p class="main-description" [innerHTML]="campaignPage.mainDescription"></p>
    <div
      class="action-btn-container"
      [innerHTML]="campaignPage.actionButton"></div>
  </div>
</div>
